import { useConfigStore, useUIStore } from '@/store';
import { Clock } from './Clock';

export function Header() {
  const title = useConfigStore((state) => state.title);
  const { toggleEditing } = useUIStore();

  return (
    <header className="text-white bg-[#062743] font-[IBM_Plex_Sans,Helvetica,Arial,sans-serif]">
      <table cellPadding="0" cellSpacing="0" className="w-full">
        <tbody>
          <tr>
            <td className="w-[60%] my-2 mx-4 flex items-center">
              <img
                src={`${import.meta.env.BASE_URL}assets/images/transit.svg`}
                alt="Transit App"
              />
            </td>

            <td className="w-1/3 mx-auto border-none text-center group">
              <h1 className="font-[IBM_Plex_Sans,Helvetica,Arial,sans-serif] text-[2em] align-middle inline-block leading-[1.4em] -mb-[0.1em] text-white">
                {title || '\u00A0'}
              </h1>
              <button
                type="button"
                className="p-0 mt-[0.45em] ml-2 inline-block w-[1.6em] h-[1.6em] bg-[url('assets/images/settings@2x.png')] bg-[length:1.6em_auto] bg-no-repeat outline-none cursor-pointer opacity-0 transition-opacity duration-300 ease-in-out align-top border-none group-hover:opacity-100"
                onClick={toggleEditing}
                aria-label="Open settings"
              />
            </td>

            <td className="w-1/3 min-w-[20em] text-right align-middle font-[IBM_Plex_Sans,Helvetica,Arial,sans-serif]">
              <Clock />
            </td>
          </tr>
        </tbody>
      </table>
    </header>
  );
}
